import { Section } from '../../../components/ui/Section';
import { asRecord, str } from '../../../platform/api/utils';
import { displayName, modalOverlay, secondaryBtn } from './obligation-detail.support';

// Aba Responsáveis do ObligationDetail (régua de 400), incluindo o modal de
// adição; estado e mutações ficam na página.
export function ObligationResponsiblesTab(props: {
  responsibles: Record<string, unknown>[];
  people: Record<string, unknown>[];
  addOpen: boolean;
  search: string;
  onOpenAdd: () => void;
  onClose: () => void;
  onSearchChange: (value: string) => void;
  onAdd: (personId: string) => void;
  onRemove: (responsibleId: string) => void;
  removing: boolean;
  canManage: boolean;
}) {
  const {
    responsibles,
    people,
    addOpen,
    search,
    onOpenAdd,
    onClose,
    onSearchChange,
    onAdd,
    onRemove,
    removing,
    canManage,
  } = props;
  return (
    <Section
      title="Responsáveis"

      action={
        canManage ? (
          <button
            type="button"
            onClick={() => {
              onOpenAdd();
            }}
            style={secondaryBtn}
          >
            + Adicionar
          </button>
        ) : undefined
      }
    >
      {responsibles.length === 0 ? (
        <p style={{ color: 'var(--faint)', fontSize: '0.875rem' }}>
          Nenhum responsável atribuído a esta obrigação.
        </p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
          {responsibles.map((raw) => {
            const r = asRecord(raw);

            const person = asRecord(r.person);

            return (
              <div
                key={str(r.id)}

                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',

                  padding: '0.5rem 0.75rem',
                  background: 'var(--paper)',
                  borderRadius: 10,

                  border: '1px solid var(--line-soft)',
                }}
              >
                <div>
                  <span style={{ fontWeight: 500, fontSize: '0.85rem' }}>
                    {displayName(person)}
                  </span>

                  {str(person.religiousName) && (
                    <span
                      style={{
                        fontSize: '0.75rem',
                        color: 'var(--faint)',
                        marginLeft: '0.5rem',
                        fontStyle: 'italic',
                      }}
                    >
                      {str(person.religiousName)}
                    </span>
                  )}
                </div>

                {canManage && (
                  <button
                    type="button"

                    onClick={() => {
                      onRemove(str(r.id));
                    }}

                    disabled={removing}

                    style={{
                      background: 'none',
                      border: '1px solid var(--danger-soft)',
                      color: 'var(--danger)',

                      borderRadius: 8,
                      padding: '0.2rem 0.5rem',
                      fontSize: '0.75rem',
                      cursor: 'pointer',
                    }}
                  >
                    Remover
                  </button>
                )}
              </div>
            );
          })}
        </div>
      )}

      {/* Modal: Adicionar responsável */}

      {addOpen && (
        <div
          style={modalOverlay}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          <div
            style={{
              background: '#fff',
              borderRadius: 14,
              padding: '1.5rem',
              minWidth: 380,
              maxWidth: 460,
            }}
          >
            <h3 style={{ margin: '0 0 0.75rem', fontSize: '1rem' }}>Adicionar responsável</h3>

            <input
              type="text"

              placeholder="Buscar pessoa..."

              value={search}

              onChange={(e) => {
                onSearchChange(e.target.value);
              }}

              style={{
                width: '100%',
                padding: '0.5rem',
                border: '1px solid var(--line)',
                borderRadius: 10,
                fontSize: '0.85rem',
                marginBottom: '0.75rem',
                boxSizing: 'border-box',
              }}

              autoFocus
            />

            <div style={{ maxHeight: 200, overflow: 'auto', marginBottom: '0.75rem' }}>
              {people
                .filter(
                  (p) =>
                    !responsibles.some((r) => {
                      const rp = asRecord(r).person as Record<string, unknown> | undefined;

                      return rp && rp.id === p.id;
                    }),
                )
                .map((p) => (
                  <div
                    key={str(p.id)}

                    onClick={() => {
                      onAdd(str(p.id));
                    }}

                    style={{
                      padding: '0.5rem 0.75rem',
                      cursor: 'pointer',
                      borderRadius: 8,

                      fontSize: '0.85rem',
                      transition: 'background 0.1s',
                    }}
                  >
                    <span style={{ fontWeight: 500 }}>{displayName(p)}</span>

                    {str(p.religiousName) && (
                      <span
                        style={{
                          fontSize: '0.75rem',
                          color: 'var(--faint)',
                          marginLeft: '0.5rem',
                          fontStyle: 'italic',
                        }}
                      >
                        {str(p.religiousName)}
                      </span>
                    )}
                  </div>
                ))}

              {people.length === 0 && (
                <p
                  style={{
                    color: 'var(--faint)',
                    fontSize: '0.85rem',
                    textAlign: 'center',
                    padding: '1rem',
                  }}
                >
                  {search ? 'Nenhuma pessoa encontrada.' : 'Digite para buscar pessoas.'}
                </p>
              )}
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <button
                type="button"
                onClick={() => {
                  onClose();
                }}
                style={secondaryBtn}
              >
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </Section>
  );
}
